import { render, staticRenderFns } from "./PaymentPending.vue?vue&type=template&id=1d12dd17&scoped=true"
import script from "./PaymentPending.vue?vue&type=script&lang=js"
export * from "./PaymentPending.vue?vue&type=script&lang=js"
import style0 from "./PaymentPending.vue?vue&type=style&index=0&id=1d12dd17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12dd17",
  null
  
)

export default component.exports